<template>
  <div id="doc-runtime-frame">
    <div id="app">
      <div id="content">
        <div class="header">
          <div class="left-buttons">
            <button @click="handleButton1" class="menu"></button>
            <button @click="showAlert()" class="btn2">受講上の注意</button>
          </div>
          <div class="right-controls">
            <div style="font-size: 22px;font-weight:400;text-align: right;"> page.{{ currentPage }}／{{
                totalPages
              }}
            </div>
            <div class="pagination">
              <button
                  class="page-btn arrow-left"
                  @click="prevPage"
                  :disabled="currentPage === 1"
                  :class="{'disabled': currentPage === 1}"
              ></button>
              <button
                  class="page-btn arrow-right"
                  @click="nextPage"
                  :disabled="currentPage === totalPages || isJspJump"
                  :class="{'disabled': currentPage === totalPages || isJspJump}"
              ></button>
            </div>
            <button class="close-btn" @click="closeWindow">終了</button>
          </div>
        </div>

        <div class="contents_frame">
          <div v-if="isVideoLoaded" class="iframe-header">
            <h1>{{ charpterName }}</h1>
          </div>
          <iframe v-if="isVideoLoaded" :key="'video-' + scoIdValue"  scrolling="no" id="iframe" src="about:blank" class="content-wrapper"></iframe>
          <iframe v-if="!isVideoLoaded" id="htmlIframe" :src="currentUrl" class="content-wrapper"></iframe>
          <div v-if="isVideoLoaded && tempFile" class="iframe-footer">
            <a :href="tempFile" class="download-btn" target="_blank">
              <span class="icon-pdf"></span>
              資料ダウンロード
            </a>
          </div>
        </div>
      </div>

      <div class="modal" tabindex="-1" v-show="noticeBack"></div>
      <div class="modal-dialog" v-show="elgmovNotice">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title noticeTitle" id="myModalLabel">
              受講上の注意
            </div>
          </div>
          <div class="modal-body">
            <div>
              受講進捗を正しく反映させるため、必ず以下のように画面を閉じてください。
              <br>
              【目次画面】
              <br>
              画面右上の『閉じる』ボタンにて閉じる
              <br>
              【学習画面】
              <br>
              画面右上の『終了』ボタンにて閉じる
            </div>
          </div>
          <div class="ok">
            <button @click="elgmovNotice=!elgmovNotice;noticeBack=!noticeBack" class="elgmovBtn">OK</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" tabindex="-1" role="dialog" aria-hidden="true" v-show="menunoticeBack"></div>
    <div class="menu-modal-dialog" v-show="menuelgmovNotice">
      <div style="text-align: right;padding-top: 10px;padding-right: 10px;">
        <button @click="menuelgmovNotice=!menuelgmovNotice;menunoticeBack=!menunoticeBack" class="menuBackBtn"></button>
      </div>
      <div class="top-text">
        {{ topText }}
      </div>
      <div class="menu-container">
        <button
            v-for="(item, index) in menuItems"
            :key="index"
            class="menu-item"
            :class="{ active: currentIndex === index }"
            @click="currentIndex = index"
        >
          {{ item.title }}
        </button>
      </div>

      <div class="content">
        <div v-if="currentIndex === 0">
          <div style="padding-bottom: 10px;">
            <button :disabled="lastStudyScoId === '' || isJspJump" @click="openLastModel()"
                    style="width: 180px;height: 40px;border: none;border-radius: 5px;font-weight: 400;font-size: 15px;">
              前回の続きから始める
            </button>
          </div>
          <div class="tree">
            <div v-for="(item, index) in flattenedData" :key="item.id"
                 :class="['node', 'level-' + item.level, { 'node-current': item.scoId === scoIdValue }]"
                 v-show="isVisible(item)"
                 @click="!hasChildren(item)"
                 @click.stop="hasChildren(item) && toggleNode(item)"
                 style="cursor: pointer">
              <div
                  class="arrow-up"
                  :class="{ 'expanded': item.expanded }"
                  v-show="hasChildren(item)"
              ></div>
              <div style="flex:3;display:flex;" @click="!hasChildren(item) && showLinkUrl(item)"
                   :style="!hasChildren(item) ? 'padding-left: 10px' : ''" :class="{'disabled-item': isJspJump}">
                <div class="node-row1">
                  <div class="node-left" :style="hasChildren(item) ? 'padding-bottom: 10px;' : ''">
                    <div class="node-text">{{ item.text }}</div>
                  </div>
                  <div v-if="!hasChildren(item)">
                    <div class="node-row2">
                      <div class="row2-div">最終受講日時</div>
                      <div class="row2-div">{{ item.dataTime }}</div>
                    </div>
                  </div>
                </div>
                <div class="node-right">
                  <div class="progress-container" v-if="!hasChildren(item) && item.linkType !== '2'"
                       :style="item.progress > 0 ? 'background: #E8F6FF;' : ''">
                    <div class="progress-bar" v-if="item.progress > 0" :style="{ width: item.progress + '%' }"></div>
                  </div>
                  <div class="fixed-div" :style="getStatusStyle(item.status)">{{ item.status }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="currentIndex === 1">
          <div style="padding-top: 45px;"></div>
          <div
              style="display: flex;padding-right: 20px;font-weight: 400;font-size: 16px; height: calc(100vh - 270px); overflow-y: auto;line-height: 24px;"
              v-dompurify-html="courseDescription">
          </div>
        </div>

        <div v-if="currentIndex === 2" class="conent2">
          <div class="container">
            <div class="progress-header">進捗率</div>
            <div style="display: flex;padding-left: 40px;padding-right: 40px;">
              <div class="progress-bar2" :style="progress > 0 ? 'background: #E8F6FF;' : ''">
                <div v-if="progress > 0" class="progress-fill" :style="{ width: progress + '%' }"></div>
              </div>
              <div
                  style="padding-left: 15px;font-weight: 400;font-size: 18px;height: 30px;justify-content: center;align-items: center;display: flex;">
                {{ progress }}%
              </div>
            </div>
          </div>

          <div class="status-header">学習状況</div>

          <div class="status-list">
            <div v-for="(item, index) in statusItems" :key="index" class="status-item">
              <div class="status-item-cell-1">{{ item.title }}</div>
              <div class="status-item-cell-2">{{ item.value }}</div>
            </div>
          </div>

          <div class="status-header">試験結果</div>

          <div style="padding-left: 40px;padding-top: 10px;padding-right: 20px;">
            <table class="rsk-table" id="rsk-table" border="0" cellspacing="0" cellpadding="0">
              <thead class="rsk-table__th rsk-table__th--expand">
              <tr class="rsk-table__tr">
                <th class="rsk-table__th rsk-table__th--expand" style="width:75%">
                  <div style="display: flex; justify-content: center;">
                    <div class="rsk-table__th-content">試験名</div>
                  </div>
                </th>
                <th class="rsk-table__th rsk-table__th--expand" style="width:25%">
                  <div style="display: flex; justify-content: center;">
                    <div class="rsk-table__th-content">点数</div>
                  </div>
                </th>
              </tr>
              </thead>
              <tbody class="rsk-table__tbody">
              <tr v-for="(item, index) in tableData" :key="index" class="rsk-table__tr">
                <td class="rsk-table__td">
                  <div
                      class="rsk-table__td-content"
                      style="justify-content: left;"
                  >
                    {{ item.examinationName }}
                  </div>
                </td>
                <td class="rsk-table__td">
                  <div class="rsk-table__td-content">{{ item.point }}</div>
                </td>
              </tr>
              </tbody>
            </table>
            <div v-if="tableData.length === 0" style="padding:10px;">
              指定された条件に一致する情報は見つかりませんでした。
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, onBeforeUnmount, inject, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import { initPopElgSco, regularUpdatePopSco } from '../../apis/lessonContent'

export default {
  name: 'App',
  setup () {
    const router = useRouter()
    const currentPage = ref(1)
    const totalPages = ref(1)
    const currentUrl = ref('')
    const elgmovNotice = ref(false)
    const menuelgmovNotice = ref(true)
    const noticeBack = ref(false)
    const menunoticeBack = ref(true)
    const topText = ref('')
    const currentIndex = ref(0)
    const service = inject('service')
    const courseDescription = ref('')
    const isVideoLoaded = ref(false)
    const charpterName = ref('')
    const tempFile = ref('')
    const scoIdList = ref([])
    const scoIdValue = ref('')
    const lastStudyScoId = ref('')
    const isJspJump = ref(false)
    const TRUSTED_ORIGIN = process.env.NODE_ENV === 'production' ? `${window.location.protocol}//${window.location.hostname}` : `${window.location.protocol}//${window.location.hostname}:8080`
    let onBeforeUnLoadEvent = false

    // ディレクトリデータ
    const flattenedData = ref([])
    const param = ref({})

    // 進捗データ
    const progress = ref(50)
    const statusItems = ref([])

    const tableData = ref([])

    const menuItems = computed(() => [
      { title: '目次' },
      { title: 'コース紹介' },
      { title: '進捗詳細' }
    ])

    const prevPage = () => {
      if (currentPage.value > 1) {
        currentPage.value--
        updateModel(scoIdValue.value)
        scoIdValue.value = scoIdList.value[currentPage.value - 1]
        checkLoginTime(scoIdValue.value)
      }
    }

    const nextPage = () => {
      if (currentPage.value < totalPages.value) {
        currentPage.value++
        updateModel(scoIdValue.value)
        scoIdValue.value = scoIdList.value[currentPage.value - 1]
        checkLoginTime(scoIdValue.value)
      }
    }

    const handleButton1 = () => {
      menuelgmovNotice.value = true
      menunoticeBack.value = true
      // 現在の展開状態を保存
      const expandedMap = new Map()
      flattenedData.value.forEach(node => {
        if (node.scoId) {
          expandedMap.set(node.scoId, node.expanded)
        }
      })
      let params = param.value
      initPopElgSco(params).then(res => {
        const scomstList = Array.isArray(res.data?.scomstList) ? res.data.scomstList : []
        if (scomstList.length === 0) {
          alert('テーブルにデータがありません。')
          window.close()
          return
        }
        flattenedData.value = transformToFlattenedData(scomstList)
        // 展開状態の復元
        flattenedData.value.forEach(node => {
          if (node.scoId && expandedMap.has(node.scoId)) {
            node.expanded = expandedMap.get(node.scoId)
          }
        })
        topText.value = res.data.elearningName
        courseDescription.value = res.data.elearningInf
        statusItems.value = transformToStatusItems(res.data)
        progress.value = res.data.progressRate || 0
        tableData.value = res.data.examinationList
        scoIdList.value = Array.isArray(res.data?.scoIdList) ? res.data.scoIdList : []
        scoIdList.value = res.data.scoIdList || []
        totalPages.value = scoIdList.value.length
        lastStudyScoId.value = res.data.scoId || ''
      })
    }

    const showAlert = () => {
      elgmovNotice.value = true
      noticeBack.value = true
    }

    const closeWindow = () => {
      onBeforeUnLoadEvent = true
      if (!isJspJump.value) {
        updateModel(scoIdValue.value)
      }
      setTimeout(() => {
        window.close()
      }, 500)
    }

    const showLinkUrl = (node) => {
      checkLoginTime(node.scoId)
      updateModel(scoIdValue.value)
    }

    const listenParentMessage = (event) => {

      if (event.origin !== TRUSTED_ORIGIN) return;

      try {
        const params = JSON.parse(event.data);

        if (!params.elearningId) {
          return;
        }

        isJspJump.value = true;
        param.value = params;
        init();
      } catch (e) {
        console.error('メッセージ解析に失敗しました', e)
        return
      }
    };

    const handleMessage = (event) => {
      if (event.origin !== TRUSTED_ORIGIN) {
        return
      }
      let data
      try {
        data = JSON.parse(event.data)
      } catch (e) {
        console.error('メッセージ解析に失敗しました', e)
        return
      }
      if (data.type === 'SET_SCORE') {
        const {
          totalScore,
          passedScore
        } = data
        SetScoreToLMS(totalScore, passedScore)
      }
    }

    window.SetScoreToLMS = function SetScoreToLMS (totalScore, passedScore) {
      let status
      if (totalScore >= passedScore) {
        status = 3
      } else {
        status = 4
      }
      let params = param.value
      const node = flattenedData.value.find(item => item.scoId === scoIdValue.value)
      params = {
        ...params,
        scoId: scoIdValue.value,
        completionStatus: status,
        totalScore: totalScore,
        videoIdFlag: node.linkType
      }
      service.lessonContent.updatePopSco(params)
    }

    function updateModel (scoId) {
      const normalizedScoId = String(scoId ?? '').trim()
      if (!normalizedScoId) return

      let params = param.value
      const node = flattenedData.value.find(item => item.scoId === normalizedScoId)
      params = {
        ...params,
        scoId: scoId,
        videoIdFlag: node.linkType
      }
      service.lessonContent.updatePopSco(params)
    }

    // タイミング送信要求
    setInterval(function () {
      if (scoIdValue.value !== '') {
        let params = param.value
        const node = flattenedData.value.find(item => item.scoId === scoIdValue.value)
        if (node.linkType === '2') {
          return
        }
        params = {
          ...params,
          scoId: scoIdValue.value,
          videoIdFlag: node.linkType,
          usrLoginLog: true
        }
        regularUpdatePopSco(params)
      }
    }, 60 * 1000)

    function checkLoginTime (scoId, reopenMenu = false) {
      service.lessonContent.check().then(res => {
        if (!res.check) {
          alert('利用時間外です。')
          window.close()
          return
        }
        initModel(scoId, reopenMenu)
      })
    }

    function initModel (scoId, reopenMenu = false) {
      let params = param.value
      params = {
        ...params,
        scoId: scoId
      }
      scoIdValue.value = scoId
      service.lessonContent.initPopSco(params).then(res => {
        if (res.status === false) {
          alert('テーブルにデータがありません。')
          window.close()
          return
        }
        if (res.videoIdFlag === '0' || res.videoIdFlag === '3') {
          isVideoLoaded.value = true
          charpterName.value = res.charpterName
          tempFile.value = res.tempFile
          nextTick(() => {
            const iframe = document.getElementById('iframe')
            if (iframe) {
              const iframeDoc = iframe.contentDocument || iframe.contentWindow.document
              iframeDoc.open()
              iframeDoc.write(res.movPlatform)
              iframeDoc.close()
            }
          })
        } else {
          isVideoLoaded.value = false
          currentUrl.value = TRUSTED_ORIGIN + '/' + res.videoId + '?parentOrigin=' + window.location.origin
        }
        if (!reopenMenu) {
          menuelgmovNotice.value = false
          menunoticeBack.value = false
        }
        currentPage.value = res.nowSco || 1
      })
    }

    const hasChildren = (node) => {
      return node.childIds !== undefined && node.childIds.length > 0
    }

    const toggleNode = (node) => {
      node.expanded = !node.expanded
    }

    const expandAncestors = (scoId) => {
      if (!scoId) return
      const node = flattenedData.value.find(item => item.scoId === scoId)
      if (!node) return
      let parentId = node.parentId
      while (parentId) {
        const parent = flattenedData.value.find(item => item.id === parentId)
        if (!parent) break
        parent.expanded = true
        parentId = parent.parentId
      }
    }

    const isVisible = (node) => {
      if (node.level === 1) return true

      if (node.parentId) {
        const parent = flattenedData.value.find(n => n.id === node.parentId)
        if (!parent || !parent.expanded) {
          return false
        }

        let currentParentId = parent.parentId
        while (currentParentId) {
          const ancestor = flattenedData.value.find(n => n.id === currentParentId)
          if (!ancestor || !ancestor.expanded) {
            return false
          }
          currentParentId = ancestor.parentId
        }
      }

      return true
    }

    const getStatusStyle = (status) => {
      if (status === '未学習') {
        return 'color:#DB5657;'
      } else if (status === '学習途中') {
        return 'color:#DAAC4C;'
      } else if (status === '修了') {
        return 'color:#85929A;'
      } else if (status === '合格') {
        return 'color:#8BC34A;'
      } else if (status === '不合格') {
        return 'color:#2196F3;'
      }
      return ''
    }

    function transformToFlattenedData (originalData) {
      const flattened = []
      const nodeMap = new Map()
      let idCounter = 1

      originalData.forEach(item => {
        const level = calculateLevel(item)
        const id = idCounter++

        const node = {
          id: id,
          level: level,
          text: item.charpterName,
          expanded: false,
          childIds: [],
          parentId: null,
          progress: item.progressPercentage || 0,
          dataTime: item.lstEntDtm || '',
          status: getStatus(item.completionStatus),
          linkurl: item.videoId || '',
          linkType: item.videoIdFlag || '',
          scoId: item.scoId || '',
          originalItem: item
        }

        const key = `${item.charpterId1}.${item.charpterId2}.${item.charpterId3}.${item.charpterId4}.${item.charpterId5}.${item.charpterId6}`
        nodeMap.set(key, node)
        flattened.push(node)
      })

      flattened.forEach(node => {
        const item = node.originalItem
        const ids = [item.charpterId1, item.charpterId2, item.charpterId3, item.charpterId4, item.charpterId5, item.charpterId6]

        for (let i = 5; i >= 0; i--) {
          if (ids[i] !== 0) {
            const parentIds = [...ids]
            parentIds[i] = 0
            for (let j = i + 1; j < 6; j++) {
              parentIds[j] = 0
            }

            const parentKey = parentIds.join('.')
            const parentNode = nodeMap.get(parentKey)

            if (parentNode && parentNode.id !== node.id) {
              node.parentId = parentNode.id
              parentNode.childIds.push(node.id)
              break
            }
          }
        }

        delete node.originalItem
      })

      return flattened
    }

    function transformToStatusItems (res) {
      return [
        {
          title: '名前',
          value: res.usrNm || ''
        },
        {
          title: '学習開始日',
          value: res.studyStartDtm || ''
        },
        {
          title: '学習修了日',
          value: res.studyEndDtm || ''
        },
        {
          title: '学習時間',
          value: res.learningTime || ''
        },
        {
          title: '最終受講',
          value: res.lastLectureDate || ''
        },
      ]
    }

    function calculateLevel (item) {
      if (item.charpterId2 === 0) return 1
      if (item.charpterId3 === 0) return 2
      if (item.charpterId4 === 0) return 3
      if (item.charpterId5 === 0) return 4
      if (item.charpterId6 === 0) return 5
      return 6
    }

    function getStatus (completionStatus) {
      if (completionStatus === 0) return '未学習'
      if (completionStatus === 1) return '学習途中'
      if (completionStatus === 2) return '修了'
      if (completionStatus === 3) return '合格'
      if (completionStatus === 4) return '不合格'
      return '未学習'
    }

    function openLastModel (reopenMenu = false) {
      checkLoginTime(lastStudyScoId.value, reopenMenu)
    }

    const init = () => {
      if (!isJspJump.value) {
        let openerData = null
        try {
          if (window.opener && window.opener.sharedData) {
            openerData = window.opener.sharedData
          }
        } catch (e) {
          // cross-origin opener blocked, fall through to sessionStorage
        }

        if (openerData) {
          param.value = openerData
        } else if (sessionStorage.getItem('sharedData')) {
          param.value = JSON.parse(sessionStorage.getItem('sharedData'))
        } else {
          router.push({ path: '/404' })
          return
        }
      }
      if (!param.value || !param.value.elearningId) {
        router.push({ path: '/404' })
        return
      }

      service.lessonContent.init(param.value).then((res) => {
        const scomstList = Array.isArray(res?.scomstList) ? res.scomstList : []
        if (scomstList.length === 0) {
          alert('テーブルにデータがありません。')
          window.close()
          return
        }
        flattenedData.value = transformToFlattenedData(scomstList)
        topText.value = res.elearningName
        courseDescription.value = res.elearningInf
        statusItems.value = transformToStatusItems(res)
        progress.value = res.progressRate || 0
        tableData.value = res.examinationList
        scoIdList.value = Array.isArray(res?.scoIdList) ? res.scoIdList : []
        scoIdList.value = res.scoIdList || []
        totalPages.value = scoIdList.value.length
        lastStudyScoId.value = res.scoId || ''
        expandAncestors(lastStudyScoId.value)

        if (!isJspJump.value) {
            if (lastStudyScoId.value === '') {
                checkLoginTime(scoIdList.value[0], true)
                updateModel(scoIdValue.value)
            } else {
                openLastModel(true)
            }
        }
      }).catch((error) => {
        console.log(error)
      })
    }

    const handlePageHide = (event) => {
      if (!onBeforeUnLoadEvent && !event.persisted) {
        updateModel(scoIdValue.value)
      }
    }

    onMounted(() => {
      window.addEventListener('message', listenParentMessage);

      window.addEventListener('message', handleMessage)
      window.addEventListener('pagehide', handlePageHide)
      try {
        if (window.opener && window.opener.sharedData) {
          param.value = window.opener.sharedData;
          init();
        } else if (sessionStorage.getItem('sharedData')) {
          param.value = JSON.parse(sessionStorage.getItem('sharedData'));
          init();
        }
      } catch (e) {
        if (sessionStorage.getItem('sharedData')) {
          param.value = JSON.parse(sessionStorage.getItem('sharedData'));
          init();
        }
      }
    })

    onBeforeUnmount(() => {
      window.removeEventListener('message', listenParentMessage);
      window.removeEventListener('message', handleMessage);
      window.removeEventListener('pagehide', handlePageHide)
    })

    return {
      currentPage,
      totalPages,
      currentUrl,
      elgmovNotice,
      menuelgmovNotice,
      noticeBack,
      menunoticeBack,
      topText,
      currentIndex,
      courseDescription,
      menuItems,
      flattenedData,
      progress,
      statusItems,
      tableData,
      service,
      prevPage,
      nextPage,
      handleButton1,
      showAlert,
      closeWindow,
      showLinkUrl,
      hasChildren,
      toggleNode,
      isVisible,
      getStatusStyle,
      isVideoLoaded,
      charpterName,
      tempFile,
      lastStudyScoId,
      openLastModel,
      SetScoreToLMS,
      TRUSTED_ORIGIN,
      scoIdValue,
      isJspJump
    }
  }
}
</script>

<style scoped>
#doc-runtime-frame #app #content {
  min-height: 100vh;
}

body {
  margin: 0;
  padding: 0;
  color: #333333;
}

.rsk-table__td-content {
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
  line-height: 1.4;
}

#doc-runtime-frame iframe {
  display: block;
  width: 100%;
  border: none;
}

.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  background-color: rgb(65, 65, 65, 0.7);
  overflow: hidden;
  outline: 0;
}

.modal-dialog {
  position: absolute;
  top: calc((100% - 300px) / 2) !important;
  left: calc((100% - 600px) / 2) !important;
  height: 300px;
  width: 600px;
  z-index: 1050;
}

.modal-content {
  position: relative;
  background-color: #fff;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid #999;
  border: 1px solid rgba(0, 0, 0, .2);
  border-radius: 6px;
  outline: 0;
  -webkit-box-shadow: 0 3px 9px rgb(0 0 0 / 50%);
  box-shadow: 0 3px 9px rgb(0 0 0 / 50%);
}

.modal-header {
  min-height: 16.43px;
  padding: 15px;
}

.noticeTitle {
  font-weight: 700;
  font-size: 28px;
  text-align: center;
  width: 230px;
  margin: auto;
  border-bottom: 1px solid #e5e5e5;
}

.modal-body {
  position: relative;
  padding: 15px;
  font-size: 16px;
  padding-left: 85px;
  padding-right: 85px;
}

.ok {
  text-align: center;
  margin-bottom: 20px;
}

.elgmovBtn {
  z-index: 1031;
  font-weight: 400;
  font-size: 16px;
  height: 40px;
  width: 100px;
  border-radius: 10px;
  background-color: #D5EBFF;
  color: #519CED;
}

button:hover:not(:disabled) {
  background-color: #2294F7;
  color: #FFFFFF;
}

button[disabled] {
  background-color: #E8E8E8;
  color: #bbbbbb;
}

.menuBackBtn {
  background-image: url(../../assets/icon/close-gray030.svg);
  background-color: #fff;
  width: 40px;
  height: 40px;
}

.menuBackBtn:hover:not(:disabled) {
  background-image: url(../../assets/icon/close-gray030-hover.svg);
}

* {
  box-sizing: border-box;
  font-family: 'Meiryo';
  font-style: normal;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px;
  width: 100%;
  box-sizing: border-box;
  top: 0;
  left: 0;
  border-bottom: 1px solid #cccccc;
}

.menu {
  background-image: url(../../assets/icon/pop-menu.svg);
  background-repeat: no-repeat;
  display: inline-block;
  height: 65px;
  width: 100px;
  background-position: center;
  padding-right: 10px;
}

.menu:hover:not(:disabled) {
  background-image: url(../../assets/icon/pop-menu-hover.svg);
}

.btn2 {
  width: 160px;
  height: 65px;
  color: #FFFFFF;
  font-weight: 400;
  font-size: 20px;
  background-color: #ED8D49;
  border: 1px solid #ED8D49;
}

.btn2:hover:not(:disabled) {
  background-color: #F2730C;
}

.contents_frame {
  max-width: 1000px;
  width: 100%;
  margin: 0 auto;
  height: calc(100vh - 100px);
}

.content-wrapper {
  max-width: 1000px;
  overflow: scroll;
}

.left-buttons {
  display: flex;
  gap: 30px;
}

.right-controls {
  display: flex;
  align-items: center;
  gap: 15px;
}

.pagination {
  display: flex;
  align-items: center;
  gap: 10px;
}

button {
  padding: 5px 10px;
  border: none;
  background-color: #D5EBFF;
  color: #519CED;
  cursor: pointer;
}

.conent2 {
  height: calc(100vh - 225px);
  overflow-y: auto;
  padding-right: 20px;
}

.close-btn {
  width: 95px;
  height: 65px;
  font-weight: 400;
  font-size: 20px;
  background-color: #A8B0BB;
  color: #FFFFFF;
}

.close-btn:hover:not(:disabled) {
  background-color: #868C99;
  color: #FFFFFF;
}

.page-btn {
  border: none;
  background: none;
  cursor: pointer;
  padding: 5px;
  width: 75px;
  height: 65px;
  background-color: #D5EBFF;
}

.page-btn:hover:not(:disabled) {
  background-color: #2294F7;
}

.arrow:hover:not(:disabled) {
  border-color: #FFFFFF;
}

.page-btn:hover:not(:disabled) .menuarrow {
  border-color: #FFFFFF;
}

.page-btn:disabled {
  color: #FFFFFF;
  cursor: not-allowed;
  background-color: #E8E8E8;
}

iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.menuarrow {
  display: inline-block;
  width: 15px;
  height: 15px;
  border-top: 3px solid #333;
  border-right: 3px solid #333;
  border-color: #519CED;
}

.arrow-left.disabled {
  background-image: url(../../assets/icon/arrow-left_50_1.svg);
}

.arrow-left {
  background-image: url(../../assets/icon/arrow-left_50_2.svg);
}

.arrow-left:hover:not(:disabled) {
  background-image: url(../../assets/icon/arrow-left_50_3.svg);
}

.arrow-right.disabled {
  background-image: url(../../assets/icon/arrow-right_50_1.svg);
}

.arrow-right {
  background-image: url(../../assets/icon/arrow-right_50_2.svg);
}

.arrow-right:hover:not(:disabled) {
  background-image: url(../../assets/icon/arrow-right_50_3.svg);
}

.page-btn:disabled .menuarrow {
  border-color: #fff;
}

.menu-modal-dialog {
  position: absolute;
  top: 5px;
  left: 5px;
  height: calc(100vh - 10px);
  width: 50%;
  z-index: 1050;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 5px 6px 9px 8px rgba(51, 51, 51, 0.2);
  max-width: 700px;
}

.menu-modal-dialog::-webkit-scrollbar-thumb {
  border: 2px solid #fff;
}

.top-text {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 27px;
  width: 560px;
  padding: 0 0 0 20px;
}

button {
  background-color: #D5EBFF;
}

.menu-container {
  display: flex;
  margin: 20px 0;
  padding-left: 20px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}

.menu-item {
  box-sizing: border-box;
  cursor: pointer;
  background-color: #FFFFFF;
  border: 1px solid #2294F4;
  border-radius: 5px;
  margin: 0;
  width: 180px;
  height: 35px;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
}

.menu-item.active {
  box-sizing: border-box;
  background: #2294F4;
  border: 1px solid #2294F4;
  border-radius: 5px;
  width: 180px;
  height: 35px;
  color: #FFFFFF;
}

.content {
  margin: 0 auto;
  padding: 0px 20px 20px;
}

.tree {
  height: calc(100vh - 305px);
  overflow-y: auto;
  padding-right: 20px;
}

.node {
  border: 1px solid #ddd;
  display: flex;
  align-items: center;
  min-height: 60px;
}

.node:hover {
  background: #EEF1F3;
}

.node-current {
  background: #EEF1F3;
}

.node + .node {
  border-top: none;
}

.node-row1 {
  flex: 1;
  padding-left: 20px;
}

.node-row2 {
  display: flex;
  padding: 5px 0;
}

.node-left {
  display: flex;
  flex: 1;
  align-items: center;
  padding: 10px 0 0 0;
  overflow: hidden;
}

.node-text {
  word-break: break-all;
  font-family: 'Meiryo';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}

.node-right {
  display: flex;
  align-items: center;
  white-space: nowrap;
  gap: 10px;
  justify-content: flex-end;
  width: 170px;
}

.progress-container {
  width: 80px;
  height: 15px;
  background: #FFFFFF;
  box-shadow: inset 0 0 0 1px #6FAFF9;
  border-radius: 50px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background-color: #6FAFF9;
}

.fixed-div {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-size: 13px;
  width: 70px;
}

.row2-div {
  margin-right: 20px;
  font-family: 'Meiryo';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 15px;
}

.arrow {
  width: 0;
  height: 0;
  border: 6px solid transparent;
  cursor: pointer;
  transition: transform 0.3s;
}

.arrow-up {
  background-image: url(../../assets/icon/folder-close.png);
  background-repeat: no-repeat;
  display: inline-block;
  height: 12px;
  width: 15px;
  background-position: center;
  padding-right: 10px;
  cursor: pointer;
}

.arrow-up.expanded {
  background-image: url(../../assets/icon/folder-open.png);
}

.level-1 {
  padding-left: 10px;
}

.level-2 {
  padding-left: 20px;
}

.level-3 {
  padding-left: 30px;
}

.level-4 {
  padding-left: 40px;
}

.level-5 {
  padding-left: 50px;
}

.level-6 {
  padding-left: 60px;
}

.progress-header {
  font-family: 'Meiryo';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 27px;
  padding: 20px 20px 10px;
  color: #333333;
}

.progress-bar2 {
  background: #FFFFFF;
  width: 100%;
  box-shadow: inset 0 0 0 1px #6FAFF9;
  border-radius: 50px;
  height: 30px;
  overflow: hidden;
}

.progress-fill {
  height: 30px;
  background: #6FAFF9;
}

.status-header {
  font-family: 'Meiryo';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 27px;
  padding: 20px 20px 0;
  color: #333333;
}

.status-list {
  box-sizing: border-box;
  padding-left: 40px;
  padding-right: 25px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 165px;
  background: #FFFFFF;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

.status-item {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  border-bottom: 1px solid #E7E7E7;
  height: 33px;
  background: #FFFFFF;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

.status-item-cell-1 {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-left: 10px;
  height: 33px;
  background: #FFFFFF;
  border-bottom: 1px solid #E7E7E7;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
  width: 196px;
}

.status-item-cell-2 {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0;
  height: 33px;
  border-bottom: 1px solid #E7E7E7;
  background: #FFFFFF;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
}

.rsk-table {
  width: 100%;
  position: relative;
  background-color: #eef1f3;
  border-bottom: 1px solid;
  border-color: rgba(48, 53, 59, .16);
}

.rsk-table__thead {
  background-color: #eef1f3;
}

.rsk-table tr {
  box-shadow: 0 -1px 0 #e6e6e6;
}

.rsk-table__th--expand {
  width: auto;
}

.rsk-table__tr {
  height: 100%;
  position: relative;
}

.rsk-table__th {
  padding-bottom: 0;
  vertical-align: middle;
  background-color: #d0e5ef;
  width: 127px;
  height: 33px;
}

.rsk-table__th-content--select {
  cursor: pointer;
}

.rsk-table__th-content {
  letter-spacing: -.2px;
  align-items: center;
  justify-content: center;
  color: #30353b;
  display: flex;
  white-space: nowrap;
  font-weight: 700;
  font-size: 15px;
  padding: 0;
  margin: 0;
  min-height: 30px;
}

.rsk-table__tbody {
  background-color: #fff;
}

.rsk-table__td {
  min-height: 36px;
  overflow-wrap: break-word;
  vertical-align: middle;
  word-wrap: break-word;
  padding: 0;
  white-space: nowrap;
}

.rsk-table__td-content {
  display: flex;
  color: #30353b;
  height: 100%;
  min-width: 30px;
  align-items: center;
  overflow-wrap: break-word;
  word-break: break-all;
  word-wrap: break-word;
  position: relative;
  min-height: 36px;
  padding: 0 8px;
  justify-content: center;
}

.status-item-cell-1,
.status-item-cell-2,
.rsk-table__th-content,
.rsk-table__td-content {
  font-size: 16px;
}

.rsk-table__th-content {
  font-size: 15px;
  font-weight: 700;
}

.status-item-cell-1,
.status-item-cell-2,
.rsk-table__td-content {
  font-weight: 400;
}

.iframe-header {
  margin-bottom: 5px;
  padding-top: 30px;
  padding-bottom: 5px;
  padding-left: 7px;
}

.iframe-header h1 {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin: 0;
  padding: 0;
}

.iframe-footer {
  text-align: right;
  margin-top: 15px;
  padding-top: 10px;
}

.download-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #e5e5e5;
  padding: 6px 12px;
  border-radius: 4px;
  text-decoration: none;
  color: #333;
  border: 1px solid #ccc;
  font-size: 14px;
  line-height: 1;
}

.icon-pdf {
  width: 18px;
  height: 18px;
  display: inline-block;
  background-image: url("../../assets/pdficon.gif");
  background-size: contain;
  background-repeat: no-repeat;
}

#iframe {
  height: 75%;
}

.disabled-item {
  cursor: not-allowed !important;
  pointer-events: none !important;
}

</style>
